import React from 'react';
import lockicon from '../../assets/lock.png';
import { useNavigate } from 'react-router-dom';

const FeaturesUnavailable = ({ ismodal, setIsmodal }) => {

  const navigate=useNavigate()
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
        <button 
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          onClick={() => setIsmodal(false)}
        >
          ✖
        </button>
        <div className="flex flex-col items-center">
            <div className='bg-[#F4F4F5] w-10 h-10 flex items-center justify-center rounded-full'>
       <img src={lockicon} alt="Lock Icon" className=" w-6 h-6 " />

            </div>
   
          <h2 className="text-xl font-semibold mb-2">Feature Unavailable</h2>
          <p className="text-center text-gray-600 mb-6">
            This feature is not available with your current plan. Would you like to upgrade?
          </p>
          <div className="flex gap-4">
          <button 
              className="px-4 py-2 text-black rounded-md border border-[#E4E4E7] bg-white shadow-md" 
              style={{ borderRadius: '6px', backgroundColor: '#FFF', border: '1px solid #E4E4E7' }}
              onClick={() => setIsmodal(false)}
            >
              Cancel
            </button>
            <button className="px-4 py-2 bg-[#18181B] text-white rounded-md" onClick={() => navigate('/plans')}>Upgrade</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesUnavailable;